import {GET_MODE} from './types';

const getMode = (prop) => dispatch=>{
    dispatch({
        type:GET_MODE,
        payload:prop
    })
}

export default getMode